/**
 * es-shipping-availability-override.js (Jeff, 2026-09-30)
 *
 * Replaces the static "Availability & Shipping" paragraph baked into a product's body_html with
 * the live, correct text computed server-side by snippets/es-shipping-line.liquid's
 * `availability_json` mode. See that file's comment for why this exists: body_html is static per
 * product, so a delivery-profile change (like removing free shipping from an outside vendor)
 * otherwise leaves every affected description stale until someone manually rewrites it.
 *
 * Fails silently and leaves the page untouched if the expected data block or DOM structure isn't
 * found -- this must never be able to break a product page, only improve it when it can.
 */
(function () {
  function run() {
    try {
      var dataEl = document.getElementById('es-availability-shipping-data');
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      if (!data || !data.applies || !data.html) return;

      var descEl = document.getElementById('engo-pd-tab-description');
      if (!descEl) return;

      var headings = descEl.querySelectorAll('h3');
      var heading = null;
      for (var i = 0; i < headings.length; i++) {
        if (/availability\s*&?\s*shipping/i.test(headings[i].textContent)) {
          heading = headings[i];
          break;
        }
      }
      if (!heading) return;

      // Walk forward from the heading to find the shipping-info card -- it's the next element
      // (after any divider bar) that actually contains a paragraph of text.
      var card = null;
      var sib = heading.nextElementSibling;
      var hops = 0;
      while (sib && hops < 6) {
        if (sib.querySelector && sib.querySelector('p')) {
          card = sib;
          break;
        }
        sib = sib.nextElementSibling;
        hops++;
      }
      if (!card) return;

      card.innerHTML = data.html;
    } catch (e) {
      // Never let a data/DOM surprise break the product page.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
